import { render } from "./PricingDrawer.vue?vue&type=template&id=33dd00d2&scoped=true"
import script from "./PricingDrawer.vue?vue&type=script&lang=js"
export * from "./PricingDrawer.vue?vue&type=script&lang=js"

import "./PricingDrawer.vue?vue&type=style&index=0&id=33dd00d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dd00d2"]])

export default __exports__